import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CommonService } from '../../services/common.service';
// This Module's Components
import { FlyoutExternalsiteComponent } from './flyout-externalsite.component';

@NgModule({
  imports: [CommonModule, ModalModule.forRoot()],
  declarations: [FlyoutExternalsiteComponent],
  exports: [FlyoutExternalsiteComponent],
  providers: [CommonService]
})
export class FlyoutExternalsiteModule {}
